import { request } from 'data/requests/request';

import { IBuyBackProduct } from 'components/BuyBack/interfaces/buyBackInterfaces';

export interface IAddBuyBackProductsRequestData {
    devices: IBuyBackProduct[];
}

const AddBuyBackProductsRequest = (data: IAddBuyBackProductsRequestData) =>
    request({
        type: 'addBuyBackProducts',
        url: `buyback/quote/addbuybackproducts`,
        method: 'POST',
        force: true,
        notApi: true,
        data,
    });

export default AddBuyBackProductsRequest;
